import React, { Component } from 'react';
import styled from 'styled-components';
import theme from '../../../theme';
import Grid from '@material-ui/core/Grid';
import DisplayEditButton from './../partials/DisplayEditButton';
import BioProgress from '../BioProgress';
import { isMobile } from 'react-device-detect';

const InfoSection = styled.div`
    border-radius: 6px;
    background-color: #f7f7f7;
    margin: 10px;
    padding: 10px;
    color: ${theme.palette.primary.main};
`;

const Category = styled.div`
    margin: 0px;
`;

const CategoryTitle = styled.p`
    color: ${theme.palette.primary.main};
    font-size: 12;
    font-weight: bold;
    margin-left: 20px;
    margin-top: 15px;
`;

const CategoryInfo = styled.div`
    background-color: #ffffff;
    border-radius: 6px;
    font-size: 12px;
    font-weight: regular;
    margin-top: 15px;
    margin-bottom: 15px;
    margin-left: 18px;
    margin-right: 18px;
    padding: 15;
`;

const LeftSide = styled.p`
    float: left;
    margin-bottom: 20px;
    margin-top: 20px;
    margin-left: 20px;
    text-align: left;
    font-size: 14px;
    font-weight: bold;
`;

const RightSide = styled.p`
    margin-left: 20px;
    float: right;
    margin-bottom: 20px;
    margin-top: 20px;
    margin-right: 20px;
    font-size: 14px;
`;

const InfoSeparator = styled.hr`
    width: 96%;
    size: 4;
    margin-top: 4px;
    margin-bottom: 4px;
`;

const CategorySeparator = styled.hr`
    width: 95%;
    size: 4;
    color: #f7f7f7;
    margin-top: 25px;
    margin-bottom: 10px;
`;

export default class FamilyDisplay extends Component {
    render() {
        const { family, kids, edit_family } = this.props;

        var children = kids.filter((kid) => kid.type.toLowerCase() === 'child');
        var pets = kids.filter((kid) => kid.type.toLowerCase() === 'pet');

        return (
            <div>
                <DisplayEditButton
                    onClickHandler={() => {
                        edit_family();
                    }}
                />
                <Grid container justify="center">
                    <Grid item sm={6} container>
                        <InfoSection id="family-info" style={{ marginBottom: 100, minWidth: '90%' }}>
                            <Category>
                                <Grid container item>
                                    <CategoryTitle>Bio</CategoryTitle>
                                    <CategoryInfo style={{ padding: 15, minWidth: '90%' }}>
                                        <Grid item>
                                            <p style={{ float: 'none', fontWeight: 'regular', fontSize: '14px' }}>
                                                {family.bio}
                                            </p>
                                        </Grid>
                                        <Grid
                                            item
                                            justify="center"
                                            style={{
                                                marginRight: 10,
                                                paddingTop: 10,
                                                height: isMobile ? '11vh' : '9vh',
                                            }}
                                        >
                                            <BioProgress bio={family.bio} />
                                        </Grid>
                                    </CategoryInfo>
                                    <CategoryTitle>Kids</CategoryTitle>
                                    <Grid item container direction="column">
                                        {children.length > 0 &&
                                            children.map((child, i) => (
                                                <CategoryInfo style={{ minWidth: '90%' }}>
                                                    <Grid container justify="space-between" item key={i}>
                                                        <LeftSide>Name</LeftSide>
                                                        <RightSide>{child.name}</RightSide>
                                                    </Grid>
                                                    <InfoSeparator />
                                                    <Grid container justify="space-between" item>
                                                        <LeftSide>Birthday</LeftSide>
                                                        {child.birthday !== undefined && child.birthday !== null && (
                                                            <RightSide>
                                                                {child.birthday.slice(5, 7) +
                                                                    '/' +
                                                                    child.birthday.slice(8, 10) +
                                                                    '/' +
                                                                    child.birthday.slice(0, 4)}
                                                            </RightSide>
                                                        )}
                                                    </Grid>
                                                    <InfoSeparator />
                                                    <Grid container justify="space-between" item>
                                                        <LeftSide>Comments</LeftSide>
                                                        <RightSide>{child.comments}</RightSide>
                                                    </Grid>
                                                </CategoryInfo>
                                            ))}
                                    </Grid>
                                    <CategoryTitle>Pets</CategoryTitle>
                                    <Grid item container direction="column">
                                        {pets.length > 0 &&
                                            pets.map((pet, i) => (
                                                <CategoryInfo style={{ minWidth: '90%' }}>
                                                    <Grid container justify="space-between" item key={i}>
                                                        <LeftSide>Name</LeftSide>
                                                        <RightSide>{pet.name}</RightSide>
                                                    </Grid>
                                                    <InfoSeparator />
                                                    <Grid container justify="space-between" item>
                                                        <LeftSide>Birthday</LeftSide>
                                                        {pet.birthday !== undefined && pet.birthday !== null && (
                                                            <RightSide>
                                                                {pet.birthday.slice(5, 7) +
                                                                    '/' +
                                                                    pet.birthday.slice(8, 10) +
                                                                    '/' +
                                                                    pet.birthday.slice(0, 4)}
                                                            </RightSide>
                                                        )}
                                                    </Grid>
                                                    <InfoSeparator />
                                                    <Grid container justify="space-between" item>
                                                        <LeftSide>Comments</LeftSide>
                                                        <RightSide>{pet.comments}</RightSide>
                                                    </Grid>
                                                </CategoryInfo>
                                            ))}
                                    </Grid>
                                </Grid>
                            </Category>
                        </InfoSection>
                    </Grid>
                </Grid>
            </div>
        );
    }
}
